import apiClient from '../api/client';

const billingService = {
    getBillingData: async () => {
        return await apiClient.get('/billing');
    },

    getRevenueStats: async () => {
        return await apiClient.get('/billing/stats');
    },

    getInvoices: async () => {
        return await apiClient.get('/billing/invoices');
    },

    getPaymentMethods: async () => {
        return await apiClient.get('/billing/payment-methods');
    },

    downloadInvoice: async (invoiceId) => {
        return await apiClient.get(`/billing/invoices/${invoiceId}/download`, {
            responseType: 'blob'
        });
    },

    getInvoiceDetail: async (invoiceId) => {
        return await apiClient.get(`/billing/invoices/${invoiceId}`);
    },

    // Preview the month's per-machine billing without saving/emailing anything.
    previewBilling: async () => {
        return await apiClient.post('/activity/generate-invoices?dryRun=1');
    },

    // Actually generate + email the month's per-machine invoices.
    generateBilling: async () => {
        return await apiClient.post('/activity/generate-invoices');
    }
};

export default billingService;
